var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3838 25.3943V23.3943C21.3838 22.3334 20.9624 21.316 20.2122 20.5659C19.4621 19.8157 18.4447 19.3943 17.3838 19.3943H9.38379C8.32292 19.3943 7.30551 19.8157 6.55536 20.5659C5.80522 21.316 5.38379 22.3334 5.38379 23.3943V25.3943M27.3838 25.3943V23.3943C27.3831 22.508 27.0881 21.6471 26.5452 20.9466C26.0022 20.2461 25.2419 19.7459 24.3838 19.5243M20.3838 7.52429C21.2442 7.74459 22.0068 8.24499 22.5514 8.9466C23.096 9.64821 23.3916 10.5111 23.3916 11.3993C23.3916 12.2875 23.096 13.1504 22.5514 13.852C22.0068 14.5536 21.2442 15.054 20.3838 15.2743M17.3838 11.3943C17.3838 13.6034 15.5929 15.3943 13.3838 15.3943C11.1746 15.3943 9.38379 13.6034 9.38379 11.3943C9.38379 9.18515 11.1746 7.39429 13.3838 7.39429C15.5929 7.39429 17.3838 9.18515 17.3838 11.3943Z",
    stroke: "#383733",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.096511b896e09758bf98bcbe42e8bb03.svg";
export { ForwardRef as ReactComponent };